import ReactGA from "react-ga4";

export default function gaPageView(path, title) {
  console.log("Logging to GA", path, title);
  ReactGA.send({ hitType: "pageview", page: path, title });
}